module.exports = __webpack_public_path__ + "img/img_1.78d10f3d.png";